import { SvgIcon, SvgIconProps } from '@mui/material'

const ChannelIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
      <path
        d="M9.99999 6.66667H3.33332C2.8913 6.66667 2.46737 6.84226 2.15481 7.15482C1.84225 7.46739 1.66666 7.89131 1.66666 8.33334V11.6667C1.66666 12.1087 1.84225 12.5326 2.15481 12.8452C2.46737 13.1577 2.8913 13.3333 3.33332 13.3333H4.16666V16.6667C4.16666 16.8877 4.25445 17.0996 4.41073 17.2559C4.56701 17.4122 4.77898 17.5 4.99999 17.5H6.66666C6.88767 17.5 7.09963 17.4122 7.25591 17.2559C7.41219 17.0996 7.49999 16.8877 7.49999 16.6667V13.3333H9.99999L14.1667 16.6667V3.33334L9.99999 6.66667ZM12.5 13L10.8333 11.6667H3.33332V8.33334H10.8333L12.5 7V13ZM17.9167 10C17.9167 11.425 17.1167 12.7167 15.8333 13.3333V6.66667C17.1083 7.29167 17.9167 8.58334 17.9167 10Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default ChannelIcon
